const getDefaultState = () => {
    return {
      productId: []
    };
  };
  
  const state = getDefaultState();
  
  const mutations = {
    SET_IDS: (state, id) => {
      state.productId = id;
    },
  };
  
  const actions = {
    setShowModel({ commit }, id) {
      commit("SET_IDS", id);
    },
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
  };
  